module.exports = __webpack_public_path__ + "static/media/11.872f9c12.png";